exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".VideoPreviewModal_dialog_root{width:500px !important;border-radius:10px !important}\n", ""]);

// Exports
exports.locals = {
	"dialog_root": "VideoPreviewModal_dialog_root"
};